/**
 * SettingsService
 * Manages application settings in localStorage
 */

const SETTINGS_KEY = 'creative_nodeflow_settings';

interface AppSettings {
  autoSaveEnabled: boolean;
}

const DEFAULT_SETTINGS: AppSettings = {
  autoSaveEnabled: true,
};

class SettingsService {
  private settings: AppSettings;

  constructor() {
    this.settings = this.loadSettings();
  }

  private loadSettings(): AppSettings {
    try {
      const stored = localStorage.getItem(SETTINGS_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        return { ...DEFAULT_SETTINGS, ...parsed };
      }
    } catch (error) {
      console.error('Failed to load settings:', error);
    }
    return { ...DEFAULT_SETTINGS };
  }

  private saveSettings(): void {
    try {
      localStorage.setItem(SETTINGS_KEY, JSON.stringify(this.settings));
    } catch (error) {
      console.error('Failed to save settings:', error);
    }
  }

  getAutoSaveEnabled(): boolean {
    return this.settings.autoSaveEnabled;
  }

  setAutoSaveEnabled(enabled: boolean): void {
    this.settings.autoSaveEnabled = enabled;
    this.saveSettings();
  }

  getAllSettings(): Readonly<AppSettings> {
    return { ...this.settings };
  }
}

// Export singleton instance
const settingsService = new SettingsService();
export default settingsService;
